import React from 'react';
import { motion } from 'framer-motion';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';

const WhatGPT3 = () => (
  <motion.div
    className="gpt3__whatgpt3 section__margin"
    id="wgpt3"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What is Prinzetuner" text="Prinzetuner is an advanced ECU modification suite engineered for professional automotive tuners. Our system intelligently analyzes ECU binaries, detects manufacturer-specific structures, and applies secure IMMO OFF and system modifications with precision. Designed for reliability. Built for experts. Powered by intelligent logic." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">Precision. Power. Control.</h1>
      <p>Where raw binary meets intelligent precision.</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="ECU Solutions" text="Professional IMMO OFF, Catalyst Disable (CAT OFF), Active Grille Shutter Disable, and precise DTC Management for automotive experts." />
      <Feature title="Smart Processing" text="Automatic Header Detection and Intelligent Gap Detection logic for Hitachi, Denso, and Kefico ECU series." />
      <Feature title="Professional Tools" text="Secure File Output with real-time monitoring and multi-series support (SIM2K, CPEG, SH705X) for fast processing." />
    </div>
  </motion.div>
);

export default WhatGPT3;
